/* eslint-disable no-prototype-builtins */
import { PhoneNumberCountries } from '@/models/VariousEnum';

/**
 * Configuration extracted from .env file for an easy access.
 */
// List of supported SU (e.g: vd, vs, fr)
export const SUPPORTED_SU = process.env.VUE_APP_SUPPORTED_SU.split(',');

// Configuration regarding app languages/locales
export const SUPPORTED_LANGUAGES = process.env.VUE_APP_SUPPORTED_LANGUAGES.split(',');
export const FALLBACK_LANGUAGE = process.env.VUE_APP_FALLBACK_LANGUAGE;

export const PUBLIC_ROOT_API = process.env.VUE_APP_PUBLIC_ROOT_API;

// App version used to force refresh the app when new update is available
export const APP_VERSION = process.env.VUE_APP_VERSION.trim();

/**
 * Phone numbers configuration for each SU
 */
const PHONE_NUMBER_COUNTRIES_MAPPING: any = {
  ge: ['ch'],
  fr: ['ch'],
  tg: ['ch'],
  vs: ['ch'],
};

export function getPhoneNumberCountriesBySu(suName: string): string[] {
  const su: string = suName.toLowerCase();
  if (!PHONE_NUMBER_COUNTRIES_MAPPING.hasOwnProperty(su)) {
    return [];
  }

  const countries = PHONE_NUMBER_COUNTRIES_MAPPING[su];
  const phoneNumberCountry = [];

  countries.forEach((element: string) => {
    phoneNumberCountry.push(PhoneNumberCountries[element.toUpperCase() as keyof typeof PhoneNumberCountries]);
  });

  return countries;
}

/**
 * Screening units id and name
 */
const SCREENING_UNITS: any = {
  1: 'fr',
  5: 'tg',
  6: 'ge',
  3: 'vs',
};

export function getScreeningUnitNameFromID(suId: string) {
  const su: number = Number(suId) % 100;
  if (!SCREENING_UNITS.hasOwnProperty(su)) {
    return '';
  }
  return SCREENING_UNITS[su];
}
